/**
 * Default platform tenant slug consumed by the global site (www)
 */
export const PLATFORM_TENANT_SLUG =
  import.meta.env.VITE_PLATFORM_TENANT_SLUG ?? "tercer-espacio";

export const PLATFORM_BASE_DOMAIN =
  import.meta.env.VITE_BASE_DOMAIN ?? "tercerespacio.com.ar";

export const PLATFORM_SITE_URL = `https://${PLATFORM_BASE_DOMAIN}`;

/**
 * Footer copy shown only on the global platform landing
 */
export const PLATFORM_LANDING_FOOTER =
  "Dirección de proyecto: Franco Heredia (Ove)\nAlias para aportes: TERCER.ESPACIO";
